<template>
  <div class="row mt-4">
    <div class="col-12">
      <h3>{{ avaliationItem.name }}</h3>
    </div>
    <div class="col-12">
      <div v-html="avaliationItem.description"></div>
    </div>
    <div class="col-12">
      <component
        :is="strategy.component"
        :avaliation-item="avaliationItem"
        :value="formData.response"
        @input="setResponse"
      />
    </div>
  </div>
</template>

<script>
import HtmlEditor from '../../Inputs/HtmlEditor.vue';
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const AVALIATION_ITEM_STRATEGIES = [
  { value: "label",        name: "Título",           component: () => import("./Strategies/LabelAvaliationItemStrategy")},
  { value: "text",         name: "Texto",            component: () => import("./Strategies/TextAvaliationItemStrategy")},
  { value: "number",       name: "Número",           component: () => import("./Strategies/NumberAvaliationItemStrategy")},
  { value: "boolean",      name: "Sim / Não",        component: () => import("./Strategies/BooleanAvaliationItemStrategy")},
  { value: "date",         name: "Data",             component: () => import("./Strategies/DateAvaliationItemStrategy")},
  { value: "select",       name: "Multipla Escolha", component: () => import("./Strategies/SelectAvaliationItemStrategy")},
  { value: "likert_scale", name: "Escala de Likert", component: () => import("./Strategies/LikertScaleAvaliationItemStrategy")},
];

export default {
  name: "AvaliationItemForm",
  components: {
    HtmlEditor,
    Multiselect,
  },
  props: {
    avaliationItem: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
    setResponse(response) {
      this.formData = Object.assign({}, this.formData, {
        avaliation_item_id: this.avaliationItem.id,
        response: response,
      });
    },
  },
  computed: {
    avaliationItemStrategies: () => AVALIATION_ITEM_STRATEGIES,
    formData: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    strategy: {
      get() {
        return this.avaliationItemStrategies.find(strategy => strategy.value === this.avaliationItem.strategy) || this.avaliationItemStrategies[0];
      },
    },

  },
}
</script>

